/**
 * @author Zarko Radojevic
 */

import React, { Component } from 'react';
import { filterBy } from '@progress/kendo-data-query';
import _ from 'lodash';
import ComboWithValue from './ComboWithValue';
import {
  ComboBoxFocusEvent,
  MultiSelectProps
} from '@progress/kendo-react-dropdowns';
import {
  ComboBoxFilterChangeEvent
} from '@progress/kendo-react-dropdowns/dist/npm/ComboBox/ComboBoxProps';
import {
  FILTER_COMBO_STATE,
  FILTER_COMBO_PROPS 
} from './Types';

export default class FilterCombo extends Component<FILTER_COMBO_PROPS, FILTER_COMBO_STATE> {
  public state = {
    initData: null,
    data: null
  };
  comboRef: any;

  /**
   * Sets props data from component state by setting component state by getDerivedStateFromProps method.
   * @param {MultiSelectProps} props
   * @param {FILTER_COMBO_STATE} state
   */
  static getDerivedStateFromProps(props: MultiSelectProps, state: FILTER_COMBO_STATE) {
    let derivedState = null;
    if (props.data !== state.initData) {
      derivedState = {
        data: props.data,
        initData: props.data
      };
    }
    return derivedState;
  }

  static defaultProps = {
    componentType: 'FilterCombo'
  }

  /**
   * Adding aria-required attribute to input - accessibility
   */
  componentDidMount() {
    const { required } = this.props;
    const component = this.comboRef.component;
    const querySelector = component?.element.querySelector('span.k-select');
    if (querySelector) {
      this.createAndAppendSpan(querySelector, 'SRL-expand');
    }
    if (required) {
      component?._input.setAttribute('aria-required', 'true');
    }
  }

  /**
   * Create and append sr-only span for accessibility
   * @param element
   * @param innerHTML
   */
  createAndAppendSpan = (element: any, innerHTML: string) => {
    if (!element?.firstChild?.classList.contains('sr-only')) {
      let span = document.createElement('span');
      span.classList.add('sr-only');
      span.innerHTML = this.props?.translateMethod?.(innerHTML, {}, 'FilterCombo');
      element.insertBefore(span, element.firstChild);
    }
  };

  onFocus = (event: ComboBoxFocusEvent) => {
    this.props.onFocus && this.props.onFocus(event);
    const component = this.comboRef.component;
    if (component._input.value !== '') {
      const removeBtn = component?.element.querySelector('span.k-clear-value.k-i-close');
      if (removeBtn) {
        removeBtn.removeAttribute('title');
        this.createAndAppendSpan(removeBtn, 'SRL-close');
      }
    }
  };

  /**
   * Sets filtered itself state
   * @param {ComboBoxFilterChangeEvent} event Event object
   */
  private filterChange = (event: ComboBoxFilterChangeEvent) => {
    if (!this.props.filterChange) {
      this.setState({
        data: filterBy(this.state.initData, event.filter)
      });
    } else {
      this.props.filterChange(event);
    }
  };

  /**
   * @inheritDoc
   */
  public render(): JSX.Element {
    const comboProps = _.omit(this.props, ['required']);
    return (
      <>
        <ComboWithValue
          {...comboProps}
          data={this.state.data}
          filterable
          onFilterChange={this.filterChange}
          onFocus={this.onFocus}
          errorTxt={this.props.errorTxt}
          ref={(el: any) => this.comboRef = el}
        />
      </>
    );
  }
}
